import { z } from 'zod'

import { RECALL_DISTRIBUTION_SYSTEM_OPTIONS } from '#app/routes/mocra+/_form+/intake-options.ts'

export const DistributionSystemEntrySchema = z.object({
	system: z.enum(
		RECALL_DISTRIBUTION_SYSTEM_OPTIONS.map((option) => option.value) as [
			(typeof RECALL_DISTRIBUTION_SYSTEM_OPTIONS)[number]['value'],
			...string[],
		],
	),
	dataset: z
		.string({
			required_error: 'Describe the dataset or report.',
		})
		.min(1, 'Describe the dataset or report.'),
})

export type DistributionSystemEntry = z.infer<
	typeof DistributionSystemEntrySchema
>
